import * as React from "react";
import UserPhonePresenterComponent from "./UserPhonePresenterComponent";

interface IProps {
	value?: string;
}

export const UserPhonePresenter: React.SFC<IProps> = (props) => {
	return (
		<UserPhonePresenterComponent userId={props.value}/>
	);
};